<template lang="pug">
  v-container#top(fluid)
    //トップイメージ
    v-layout.jumbotron(column align-center)
      v-flex.jumbotron-contents.text-xs-center
        h1.display-4(style="padding-bottom:0.3em;") Tsuruhashi Records?
        p.headline Tsuruhashi Recordsは「ミュージックカルチャーの開拓・再発掘」をテーマとした<br>ジャンルフリー、メンバー不定のネットレーベルです。
    v-layout#about(align-center)
      v-flex.text-xs-left(row wrap)
        article
          h1.display-2 Description
          p.subheading
            |"Tsuruhashi Records" は2014年にOshakによって設立された、<br>
            |「ミュージックカルチャーの開拓・再発掘」をテーマとした日本のオンライン・レーベルです。<br>
        article
          h1.display-1 Licence Agreement
          p.subheading
            |Tsuruhashi Recordsのすべての作品は
            span
              a(href="https://creativecommons.org/licenses/by-nc-sa/2.1/jp/") Creative Commons — 表示-非営利-継承 2.1
            |のライセンスの下に提供されます。
          p.subheading Tsuruhashi Recordsは「ミュージックカルチャーの開拓・再発掘」をテーマとしています。<br>非営利、無償でのコンテンツ提供を行っておりますので、金銭等の報酬をご用意することはできません。あらかじめご了承ください。

        article
          h1.display-1 Wanted
          p.subheading Tsuruhashi Recordsでは以下のクリエイターを募集しています。
          h2.title Sound Creator
          p.body-1 クールでノスタルジックな楽曲を創造する人材をTsuruhashi Recordsは求めています。<br>それは必ずあなたの力となり、このレーベルが羽ばたくための翼となるでしょう。
          h2.title Illustrator / Photographer
          p.body-1 あなたが創り出した、もしくは切り取った世界を多くの人に伝えたいならば、<br>Tsuruhashi Recordsがそれを手助けします。あなたは一人ではありません。
          h2.title ArtWork Designer
          p.body-1 ほんの1mm、たった1mmへのこだわりが世界を変えていきます。<br>あなたの持つその類まれなる才覚をTsuruhashi Recordsは決して無駄にはしません。
          h2.title Engineer
          p.body-1 我々はただ、世の女性から迫害されるだけのために技術を高め、知識を蓄え、茨の道を歩んできたのではありません。<br>Tsuruhashi Recordsはあなたのような人を待っていました。
          v-btn.pink(href="wanted") wanted page
            i.fas.fa-chevron-circle-right(style="margin-left:0.5em;")
          v-btn.blue(href="contact") contact
            i.fas.fa-chevron-circle-right(style="margin-left:0.5em;")
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
article {
  padding-bottom: 50px;
}
#top {
  padding: 0;
}
@mixin display-size-page {
  min-height: 100vh;
  min-width: 100vw;
  padding-right: 10%;
  padding-left: 10%;
}
.jumbotron {
  @include display-size-page;
  background-size: cover;
  background-position: center;
  background-image: url("../assets/images/top.jpg");
}
.jumbotron-contents {
  @include display-size-page;
  padding-top: 30vh;
  background: rgba(0,0,0,0.4)
}
#about {
  @include display-size-page;
  padding-top: 10%;
  padding-bottom: 10%;
}
.title {
  padding-bottom: 0.2em;
}
</style>
